import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { State } from '../state/state';
import {
  createServiceImageViewModel,
  ServiceImageViewModel,
} from './serviceImageViewModel/serviceImageViewModel';
import { Image } from '@wix/ambassador-bookings-services-v2-service/types';
import { AsyncComponentDataStatus } from '../../types';

export type ViewModel = {
  bodyViewModel: {
    services: {
      id: string;
      name: string;
      description: string;
      image?: Image;
    }[];
  };
  serviceImageViewModel: ServiceImageViewModel;
  isSEO: boolean;
};

export const createViewModel = ({
  flowAPI,
  state,
}: {
  flowAPI: ControllerFlowAPI;
  state: State;
}): ViewModel => {
  const {
    environment: { isSEO, isEditor, isPreview },
  } = flowAPI;
  if (state.services.status !== AsyncComponentDataStatus.IDLE) {
    return {
      serviceImageViewModel: createServiceImageViewModel({ flowAPI }),
      bodyViewModel: {
        services: [],
      },
      isSEO,
    };
  }
  const hasServices = state.services.data.services.length > 0;

  if (!hasServices && (isEditor || isPreview)) {
    return {
      serviceImageViewModel: createServiceImageViewModel({ flowAPI }),
      bodyViewModel: {
        services: [
          createDummyService(flowAPI, 0),
          createDummyService(flowAPI, 1),
          createDummyService(flowAPI, 2),
        ],
      },
      isSEO,
    };
  }

  return {
    serviceImageViewModel: createServiceImageViewModel({ flowAPI }),
    bodyViewModel: {
      services: state.services.data.services.map((service) => ({
        id: service.id!,
        name: service.name!,
        description: service.description!,
        image: service.media?.mainMedia?.image,
      })),
    },
    isSEO,
  };
};

const dummyServiceImages = [
  '11062b_7be34dd7781a419892b217eae1188612~mv2.jpg',
  '11062b_64186737b5f44cb683764b92c4bb7791~mv2.jpg',
  '11062b_c5819ae1c5684aaa898164ccde6e970c~mv2.jpg',
];

export const createDummyService = (
  flowAPI: ControllerFlowAPI,
  index: number,
) => {
  const {
    translations: { t },
  } = flowAPI;
  return {
    id: index.toString(),
    name: t('wix-services.service_name'),
    description: t('wix-services.service_description'),
    image: {
      width: 5161,
      height: 3492,
      url: dummyServiceImages[index],
      filename: dummyServiceImages[index],
    },
  };
};
